'use strict';

import { Cluster } from '../../../../app/resources/cluster/cluster.interface';

(function () {
  angular
    .module('specsguardApp')
    .controller('AddClusterController', AddClusterController);

  AddClusterController.$inject = ['$scope', '$rootScope', '$stateParams', 'Project', 'building', 'errorMessageService',
    'ProjectDataservice', '$mdDialog', 'model', 'versionId', 'Labels', 'sg2ProjectService'];

  function AddClusterController ($scope, $rootScope, $stateParams, Project, building, errorMessageService,
    ProjectDataservice, $mdDialog, model, versionId, Labels, sg2ProjectService) {

    $scope.model = model ? model : {};
    $scope.cluster = {cluster: {}};
    $scope.LABELS = Labels;

    $scope.submitCluster = function (addAnother) {
      function update (updatedProject) {

        const msg = ($scope.model.edit ?
          $scope.LABELS.getLabel('clusteredited') : $scope.LABELS.getLabel('clusteradded'));

        ProjectDataservice.setProjectById(updatedProject._id, updatedProject);

        // When updating the cluster, broadcast the new cluster to the area controller so
        // the change in title / code will be live.
        // NOTE: API changed so updatedProject is actually updatedCluster.
        if ($scope.model.edit) {
          $rootScope.$broadcast('updateCluster', updatedProject);
        }

        errorMessageService.showSuccess(msg);
        if (!addAnother) {
          $scope.cancel(updatedProject);
        } else {
          $scope.model = {};
          $scope.form.$setPristine(true);
          $scope.form.$setUntouched(true);
          // updateProject(updatedProject);
        }
      }

      const form = $scope.form;

      $scope.submitted = true;

      if (form.$valid) {
        $scope.cluster._id = $stateParams.project_id || $stateParams.projectId;
        $scope.cluster.paramId = building._id;
        $scope.cluster.versionId = versionId;

        $scope.cluster.cluster.name = $scope.model.name;
        $scope.cluster.cluster.shortCode = $scope.model.shortCode;

        if (!$scope.model.edit) {

          // When creating a new cluster, the new cluster is recreated locally from response and known data.
          // This new cluster is send *directly* to ProjectService.addCluster(), which is not the right
          // way to do. After migration, this block below should change to just ClusterService.add(),
          // which handles all the logic, including the modal, the API call and the Project patching.
          Project.addCluster($scope.cluster).$promise.then(updatedProject => {
            const updatedBuilding = updatedProject.buildings.find(b => b._id === building._id);
            const newCluster = {
              ...updatedBuilding.clusters[updatedBuilding.clusters.length - 1],
              buildingId: building._id
            } as Cluster;
            update(updatedProject);
            sg2ProjectService.addCluster(newCluster);
          });
        } else {
          $scope.cluster.cluster.clusterId = $scope.model._id;
          Project.editCluster($scope.cluster).$promise.then(update);
        }
      }
    };

    $scope.cancel = (updatedProject) => {
      $mdDialog.hide(updatedProject);
    };

    $scope.checkDuplicateClusterAttribute = (key) => {
      if (!$scope.model[key]) {
        return;
      }

      const clusters = building.clusters;
      const isValid = !clusters.find((cluster) => cluster[key].toLowerCase() === $scope.model[key].toLowerCase());
      $scope.form[key].$setValidity('duplicate', isValid);
    };
  }

})();
